import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import api from "../lib/api";

const LOGO_URL =
  "/assets/logo.png";

const PaymentSuccess = () => {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [state, setState] = useState({ status: "checking", message: "Vérification du paiement…" });
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) {
      setState({ status: "error", message: "Aucune session de paiement trouvée." });
      return;
    }
    let attempts = 0;
    let cancelled = false;

    const poll = async () => {
      attempts += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (res.data.payment_status === "paid") {
          setState({ status: "paid", message: "Paiement confirmé." });
          setTimeout(() => nav(`/signup?session_id=${sessionId}`), 1200);
          return;
        }
        if (res.data.status === "expired") {
          setState({ status: "error", message: "La session de paiement a expiré." });
          return;
        }
        if (attempts >= 8) {
          setState({ status: "error", message: "Délai dépassé. Si vous avez été débité, contactez-nous." });
          return;
        }
        setTimeout(poll, 2000);
      } catch (e) {
        if (attempts >= 8) {
          setState({ status: "error", message: "Erreur lors de la vérification." });
        } else {
          setTimeout(poll, 2000);
        }
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, nav]);

  return (
    <div className="min-h-screen bg-white flex flex-col px-5 marketing-mobile-shrink">
      <header className="pt-6 pb-2">
        <Link to="/" className="inline-flex items-center" data-testid="logo-link">
          <img src={LOGO_URL} alt="Le Guide des Entrepreneurs" className="h-9 sm:h-10 w-auto" />
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-md w-full text-center" data-testid="payment-success-page">
          {state.status === "checking" && (
            <>
              <Loader2 className="w-12 h-12 animate-spin mx-auto text-[#1E2A5E]" />
              <h1 className="font-heading font-black text-3xl tracking-tighter mt-6">{state.message}</h1>
              <p className="text-gray-600 mt-3">Merci de patienter, nous confirmons votre paiement auprès de Stripe…</p>
            </>
          )}
          {state.status === "paid" && (
            <>
              <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-500" />
              <h1 className="font-heading font-black text-3xl tracking-tighter mt-6">Paiement confirmé</h1>
              <p className="text-gray-600 mt-3">Vous allez être redirigé pour créer votre compte…</p>
            </>
          )}
          {state.status === "error" && (
            <>
              <XCircle className="w-14 h-14 mx-auto text-red-500" />
              <h1 className="font-heading font-black text-3xl tracking-tighter mt-6">Un problème est survenu</h1>
              <p className="text-gray-600 mt-3">{state.message}</p>
              <Button onClick={() => nav("/")} className="mt-6 rounded-none bg-[#1E2A5E] hover:bg-[#2FA398]" data-testid="back-home-btn">
                Retour à l'accueil
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
